import { render, staticRenderFns } from "./03-Capture.vue?vue&type=template&id=c854f6a4&scoped=true&"
import script from "./03-Capture.vue?vue&type=script&lang=js&"
export * from "./03-Capture.vue?vue&type=script&lang=js&"
import style0 from "./03-Capture.vue?vue&type=style&index=0&id=c854f6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c854f6a4",
  null
  
)

export default component.exports